import { saveCheckpoint } from "./memory.js";
import { checkAlarmClearNarration } from "./roomNarration.js";
import { AUDIO_SOUNDS, playUi, stopAlarmAudio } from "./audio.js";

const lockedRoomIds = new Set();
const liveGuardRobotCountByRoom = new Map();

export function clearAlarmLockdowns() {
    lockedRoomIds.clear();
    liveGuardRobotCountByRoom.clear();
    stopAlarmAudio();
}

export function registerGuardRobotRoom(roomId) {
    if (roomId == null) return;
    liveGuardRobotCountByRoom.set(roomId, (liveGuardRobotCountByRoom.get(roomId) ?? 0) + 1);
}

export function unregisterGuardRobotRoom(roomId) {
    if (roomId == null) return;
    const nextCount = Math.max(0, (liveGuardRobotCountByRoom.get(roomId) ?? 0) - 1);
    if (nextCount > 0) {
        liveGuardRobotCountByRoom.set(roomId, nextCount);
    } else {
        liveGuardRobotCountByRoom.delete(roomId);
    }
}

export function lockAlarmRoom(roomId) {
    if (roomId == null) return;
    lockedRoomIds.add(roomId);
}

/**
 * Clear a room alarm. When an alarm actually turns off, snapshot a checkpoint
 * at the player's current position for that room.
 */
export function unlockAlarmRoom(roomId) {
    if (roomId == null || !lockedRoomIds.has(roomId)) return false;
    lockedRoomIds.delete(roomId);
    if (lockedRoomIds.size === 0) {
        stopAlarmAudio();
        playUi(AUDIO_SOUNDS.alarmClear);
    }
    checkpointAfterAlarmClear(roomId);
    checkAlarmClearNarration(roomId);
    return true;
}

export function isAlarmRoomLocked(roomId) {
    if (roomId == null || !lockedRoomIds.has(roomId)) return false;
    return true;
}

export function hasActiveAlarmLockdown() {
    return lockedRoomIds.size > 0;
}

export function updateAlarmLockdowns() {
    Array.from(lockedRoomIds).forEach((roomId) => {
        if ((liveGuardRobotCountByRoom.get(roomId) ?? 0) <= 0) {
            unlockAlarmRoom(roomId);
        }
    });
}

function checkpointAfterAlarmClear(roomId) {
    const player = get("player")?.[0];
    if (!player?.exists?.() || player.isDead) return;

    const pos = vec2(player.pos.x, player.pos.y);
    saveCheckpoint(pos, roomId);
}
